import script from "./DriveView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DriveView.vue?vue&type=script&setup=true&lang=ts"

import "./DriveView.vue?vue&type=style&index=0&id=247bffec&lang=css"

const __exports__ = script;

export default __exports__